import { render, staticRenderFns } from "./ModuleNewsletter.vue?vue&type=template&id=b0b0f9c8"
import script from "./ModuleNewsletter.vue?vue&type=script&lang=ts"
export * from "./ModuleNewsletter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports